import { useEffect, useState } from 'react';
import LoadingSpinner from '../components/layout/LoadingSpinner';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import store, { RootState } from '../store';
import { useGetLeadAcademyQuery } from '../api/lead-academy';
import { setLeadAcademyData } from '../features/leadAcademy/leadAcademySlice';

const LeadGroupAcademy = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [iframeSrc, setIframeSrc] = useState<string | null>(null);
    const [hasRedirected, setHasRedirected] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const user = useSelector((state: RootState) => state.auth.user);
    const school_id = store.getState().SchoolInfo.data.school.id;

    const { data: lead_academy_res, isError: lead_academy_error, isLoading: apiLoading } =
        useGetLeadAcademyQuery({ school_id: school_id }) as any;
    useEffect(() => {
        if (lead_academy_res?.data?.leadAcademyUrl) {
            dispatch(setLeadAcademyData(lead_academy_res));
            setIframeSrc(lead_academy_res.data.leadAcademyUrl);
        }
    }, [lead_academy_res, dispatch]);

    const isRedirectFromWidget = searchParams.get('fromPendingActions') === 'true';
    const catId = searchParams.get('catId');
    const tagNid = searchParams.get('tagNid');

    const handleLoad = () => {
        if (!isRedirectFromWidget || hasRedirected || !catId || !tagNid) {
            setIsLoading(false);
            return;
        }

        if (
            isRedirectFromWidget &&
            !hasRedirected &&
            lead_academy_res?.data?.leadAcademyUrl &&
            catId &&
            tagNid
        ) {
            try {
                const originalUrl = new URL(lead_academy_res.data.leadAcademyUrl);
                const origin = originalUrl.origin;
                const finalUrl = `${origin}/v2/category?catid=${catId}&tag_nid=${tagNid}`;
                setHasRedirected(true);
                setTimeout(() => {
                    setIframeSrc(finalUrl);
                    setIsLoading(false);
                }, 2000);
            } catch (error) {
                console.error('Error constructing finalUrl:', error);
                setIframeSrc(lead_academy_res.data.leadAcademyUrl);
                setIsLoading(false);
            }
        }
    };

    return (
        <>
            <div className="w-full h-full">
                {(isLoading || apiLoading) && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                        <LoadingSpinner />
                    </div>
                )}
                <iframe
                    className="content-iframe w-full h-full transition-opacity duration-500 ease-in-out"
                    title="Lead Academy Content"
                    src={iframeSrc || ''}
                    onLoad={handleLoad}
                    style={{ opacity: isLoading ? 0 : 1 }}
                ></iframe>
            </div>
        </>
    );
};

export default LeadGroupAcademy;
